import React, { useEffect } from 'react';
import {
  bool, node, func, number, exact, arrayOf, string,
} from 'prop-types';
import { Link } from 'react-scroll';
import styled, { css } from 'styled-components';
import { Flex, Loader, Button } from '@atoms';
import { Footer, ErrorToast, MenuHeader } from '@molecules';

const Menu = ({
  onToastClose,
  hasServerError,
  footerChild,
  children,
  isLoading,
  onBackUp,
  isFooterVisible,
  hasBackToTopButton,
  hasBackUpButton,
  hasMarginBottom,
  categories,
  subcategories,
  selectedCategoryId,
  isSubcategoryBarVisible,
}) => {
  useEffect(() => {
    document.title = 'Menu';
  }, []);

  return (
    <>
      <Wrapper
        hasMarginBottom={hasMarginBottom}
        isFooterVisible={isFooterVisible}
        id="top"
        column
      >
        <MenuHeader
          isSubcategoryBarVisible={isSubcategoryBarVisible}
          categories={categories}
          subcategories={subcategories}
          selectedCategoryId={selectedCategoryId}
        />
        <Flex column grow={0}>
          {children}
        </Flex>
        {isFooterVisible && (
          <Footer onBackUp={onBackUp} hasBackUpButton={hasBackUpButton}>
            {footerChild}
          </Footer>
        )}
        {hasBackToTopButton && !isLoading && (
          <Flex selfCenter padding="xl4">
            <Link to="top" spy smooth>
              <Button.Rectangular
                primary
                gradient
                padding="xl2"
                paddingLeft="xl6"
                paddingRight="xl6"
              >
                Back to top
              </Button.Rectangular>
            </Link>
          </Flex>
        )}
      </Wrapper>
      {isLoading && <Loader />}
      {hasServerError && <ErrorToast onToastClose={onToastClose} />}
    </>
  );
};

const Wrapper = styled(Flex)`
  ${({ hasMarginBottom, isFooterVisible }) => css`
    position: relative;

    ${isFooterVisible && hasMarginBottom && `
      min-height: calc(100% - 108.4px);
      margin-bottom: 108.4px;
    `}
  `}
`;

Menu.defaultProps = {
  onToastClose: () => {},
  hasServerError: false,
  hasBackUpButton: true,
  hasBackToTopButton: false,
  isLoading: false,
  footerChild: null,
  onBackUp: () => {},
  isFooterVisible: true,
  hasMarginBottom: true,
};

Menu.defaultProps = {
  isSubcategoryBarVisible: true,
  selectedCategoryId: 0,
};

Menu.propTypes = {
  isSubcategoryBarVisible: bool,
  categories: arrayOf(exact({
    imageSrc: string,
    title: string,
    isActive: bool,
    id: number,
  })).isRequired,
  subcategories: arrayOf(exact({
    title: string,
    id: number,
  })).isRequired,
  selectedCategoryId: number,
  onToastClose: func,
  hasServerError: bool,
  hasBackUpButton: bool,
  hasBackToTopButton: bool,
  children: node.isRequired,
  isLoading: bool,
  onBackUp: func,
  footerChild: node,
  isFooterVisible: bool,
  hasMarginBottom: bool,
};

export default Menu;
